export default () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.12305 1.63541C6.12305 1.42501 6.30213 1.25446 6.52305 1.25446H11.0564C11.2773 1.25446 11.4564 1.42501 11.4564 1.63541V15.5402C11.4564 15.7506 11.2773 15.9211 11.0564 15.9211H6.52305C6.30213 15.9211 6.12305 15.7506 6.12305 15.5402V1.63541ZM6.92305 2.01636V15.1592H10.6564V2.01636H6.92305Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.87305 1.63541C5.87305 1.27559 6.1757 1.00446 6.52305 1.00446H11.0564C11.4037 1.00446 11.7064 1.27559 11.7064 1.63541V15.5402C11.7064 15.9 11.4037 16.1711 11.0564 16.1711H6.52305C6.1757 16.1711 5.87305 15.9 5.87305 15.5402V1.63541ZM6.52305 1.50446C6.42857 1.50446 6.37305 1.57444 6.37305 1.63541V15.5402C6.37305 15.6011 6.42857 15.6711 6.52305 15.6711H11.0564C11.1509 15.6711 11.2064 15.6011 11.2064 15.5402V1.63541C11.2064 1.57444 11.1509 1.50446 11.0564 1.50446H6.52305ZM6.67305 2.01636C6.67305 1.87829 6.78498 1.76636 6.92305 1.76636H10.6564C10.7945 1.76636 10.9064 1.87829 10.9064 2.01636V15.1592C10.9064 15.2973 10.7945 15.4092 10.6564 15.4092H6.92305C6.78498 15.4092 6.67305 15.2973 6.67305 15.1592V2.01636ZM7.17305 2.26636V14.9092H10.4064V2.26636H7.17305Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.12305 7.7795C8.12305 7.7269 8.16782 7.68427 8.22305 7.68427H9.35638C9.41161 7.68427 9.45638 7.7269 9.45638 7.7795C9.45638 7.8321 9.41161 7.87474 9.35638 7.87474H8.22305C8.16782 7.87474 8.12305 7.8321 8.12305 7.7795Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.87305 7.7795C7.87305 7.57748 8.04138 7.43427 8.22305 7.43427H9.35638C9.53805 7.43427 9.70638 7.57748 9.70638 7.7795C9.70638 7.98153 9.53805 8.12474 9.35638 8.12474H8.22305C8.04138 8.12474 7.87305 7.98153 7.87305 7.7795Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.58984 5.28431C6.58984 5.13703 6.7152 5.01764 6.86984 5.01764H10.7098C10.8645 5.01764 10.9898 5.13703 10.9898 5.28431C10.9898 5.43158 10.8645 5.55097 10.7098 5.55097H6.86984C6.7152 5.55097 6.58984 5.43158 6.58984 5.28431Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.33984 5.28431C6.33984 4.9876 6.58877 4.76764 6.86984 4.76764H10.7098C10.9909 4.76764 11.2398 4.9876 11.2398 5.28431C11.2398 5.58101 10.9909 5.80097 10.7098 5.80097H6.86984C6.58877 5.80097 6.33984 5.58101 6.33984 5.28431ZM6.83984 5.28424C6.83984 5.28427 6.83984 5.28429 6.83984 5.28431C6.83984 5.28432 6.83984 5.28434 6.83984 5.28437C6.83984 5.28503 6.83981 5.28759 6.84427 5.29183C6.84909 5.29642 6.85759 5.30097 6.86984 5.30097H10.7098C10.7221 5.30097 10.7306 5.29642 10.7354 5.29183C10.7399 5.28759 10.7399 5.28503 10.7398 5.28437L10.7398 5.28431L10.7398 5.28424C10.7399 5.28358 10.7399 5.28102 10.7354 5.27678C10.7306 5.27219 10.7221 5.26764 10.7098 5.26764H6.86984C6.85759 5.26764 6.84909 5.27219 6.84427 5.27678C6.83981 5.28102 6.83984 5.28358 6.83984 5.28424Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.58984 9.1717C6.58984 9.02442 6.7152 8.90503 6.86984 8.90503H10.7098C10.8645 8.90503 10.9898 9.02442 10.9898 9.1717C10.9898 9.31897 10.8645 9.43836 10.7098 9.43836H6.86984C6.7152 9.43836 6.58984 9.31897 6.58984 9.1717Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.33984 9.1717C6.33984 8.87499 6.58877 8.65503 6.86984 8.65503H10.7098C10.9909 8.65503 11.2398 8.87499 11.2398 9.1717C11.2398 9.4684 10.9909 9.68836 10.7098 9.68836H6.86984C6.58877 9.68836 6.33984 9.4684 6.33984 9.1717ZM6.83984 9.17163C6.83984 9.17166 6.83984 9.17168 6.83984 9.1717C6.83984 9.17171 6.83984 9.17173 6.83984 9.17176C6.83984 9.17242 6.83981 9.17498 6.84427 9.17922C6.84909 9.18381 6.85759 9.18836 6.86984 9.18836H10.7098C10.7221 9.18836 10.7306 9.18381 10.7354 9.17922C10.7399 9.17498 10.7399 9.17242 10.7398 9.17176L10.7398 9.1717L10.7398 9.17163C10.7399 9.17097 10.7399 9.16841 10.7354 9.16417C10.7306 9.15958 10.7221 9.15503 10.7098 9.15503H6.86984C6.85759 9.15503 6.84909 9.15958 6.84427 9.16417C6.83981 9.16841 6.83984 9.17097 6.83984 9.17163Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.12305 15.5878C4.12305 15.4037 4.29245 15.2545 4.50143 15.2545H13.078C13.287 15.2545 13.4564 15.4037 13.4564 15.5878C13.4564 15.7719 13.287 15.9211 13.078 15.9211H4.50143C4.29245 15.9211 4.12305 15.7719 4.12305 15.5878Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.87305 15.5878C3.87305 15.2368 4.1851 15.0045 4.50143 15.0045H13.078C13.3943 15.0045 13.7064 15.2368 13.7064 15.5878C13.7064 15.9388 13.3943 16.1711 13.078 16.1711H4.50143C4.1851 16.1711 3.87305 15.9388 3.87305 15.5878ZM4.39913 15.5397C4.37797 15.5583 4.37305 15.5758 4.37305 15.5878C4.37305 15.5997 4.37797 15.6173 4.39913 15.6359C4.42077 15.655 4.4562 15.6711 4.50143 15.6711H13.078C13.1232 15.6711 13.1587 15.655 13.1803 15.6359C13.2015 15.6173 13.2064 15.5997 13.2064 15.5878C13.2064 15.5758 13.2015 15.5583 13.1803 15.5397C13.1587 15.5206 13.1232 15.5045 13.078 15.5045H4.50143C4.4562 15.5045 4.42077 15.5206 4.39913 15.5397Z"
      fill="currentColor"
    />
  </svg>
);
